import { getTvObject, tv } from '@costar-ui/cosmos';
import surfaceOptions from '../../common/surface-options/surface-options.esm.js';

var overlayArrowTvObject = getTvObject({
  base: ['size-3', 'border-l-[1px]', 'border-t-[1px]', 'border-neutral', 'group-placement-left:translate-x-[-.3125rem]', 'group-placement-left:rotate-[135deg]', 'group-placement-right:translate-x-[.3125rem]', 'group-placement-right:rotate-[315deg]', 'group-placement-top:translate-y-[-.3125rem]', 'group-placement-top:rotate-[225deg]', 'group-placement-bottom:translate-y-[.3125rem]', 'group-placement-bottom:rotate-[45deg]'],
  variants: {
    color: surfaceOptions.color
  }
});
var overlayArrowStyles = tv(overlayArrowTvObject);

export { overlayArrowStyles, overlayArrowTvObject };
//# sourceMappingURL=overlay-arrow.styles.esm.js.map
